import { FC, useEffect, useMemo, useRef, useState } from 'react';
import { markTypeEnum } from '@/views/iterate/pages/siteselectionmapb/ts-config';
import SiteMapExplainExtra from '@/common/components/business/SiteMap/SiteMapExplainExtra';
import IconFont from '@/common/components/IconFont';
import { getClusterScores, getShareClusterScores } from '@/common/api/youth';
import { fullEditorCss } from '@/common/components/config-v2';

/**
 * @Description 评分介绍icon
 */
const ScoreExplaimIcon:FC<{
  data: any; // 商圈数据
  predictSale: any; // 是否展示预测营业额
  className?: any;
  modelConfigId:any;
  shareParams?:any;
  showScoreDescriptionFlag?: any;
  scoreDescription?: any;
}> = ({
  data,
  predictSale,
  className,
  modelConfigId,
  shareParams,
  showScoreDescriptionFlag,
  scoreDescription,
}) => {
  const shadowRef: any = useRef();
  const [descriptions, setDescriptions] = useState<any>(null);

  // 四维评分时弹框中展示的评分文案
  const extraParagraph = useMemo(() => {
    const { markType } = data || {};
    if (markTypeEnum.four !== markType) return null;
    if (!descriptions) return null;
    const parag = {
      title: '评分说明',
      descriptions
    };
    return parag;
  }, [data, descriptions]);


  // 初始化时获取评分说明
  useEffect(() => {
    if (markTypeEnum.four !== data?.markType) return;
    const api = Object.keys(shareParams)?.length ? getShareClusterScores : getClusterScores;
    api({
      id: data?.id,
      modelConfigId: modelConfigId
    }).then((scores) => {
      const descriptionsInfo = scores.filter(itm => !!itm.name && !!itm.msg).map(itm => `${itm.name}：${itm.msg}`);
      setDescriptions(descriptionsInfo);
    });
  }, [data]);

  return (
    <IconFont
      iconHref='iconxq_ic_shuoming_normal'
      className={className}
      tooltipConfig={{
        placement: 'bottom',
        overlayInnerStyle: {
          width: '320px',
          padding: '16px',
          boxSizing: 'border-box',
          borderRadius: '4px',
          maxHeight: 'calc(50vh)',
          overflowY: 'auto',
        },
        color: '#fff',
        onOpenChange(open) {
          // left: 737px; top: 137px; transform-origin: 50% -4px;
          if (showScoreDescriptionFlag === 2 && scoreDescription && open) {
            setTimeout(() => {
              // 创建Shadow DOM根节点
              const shadowRoot = shadowRef.current.attachShadow({ mode: 'open' });
              const contentDiv = document.createElement('div');
              contentDiv.innerHTML = scoreDescription;
              // 创建样式
              const style = document.createElement('style');
              style.textContent = fullEditorCss;
              // 添加到Shadow DOM
              shadowRoot.appendChild(style);
              shadowRoot.appendChild(contentDiv);
            }, 1);
          }
        },
        title: showScoreDescriptionFlag === 2 ? (
          <div ref={shadowRef}></div>
        ) : (
          <SiteMapExplainExtra
            markType={data?.markType}
            isPredictSale={predictSale}
            extraParagraphs={extraParagraph ? [extraParagraph] : []}
          />
        ),
      }}/>
  );
};

export default ScoreExplaimIcon;
